import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginCliente } from '../services/api';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    senha: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await loginCliente(formData);
      
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('cliente', JSON.stringify(response.data.cliente));
      
      toast.success('Login realizado com sucesso!');
      const cliente = response.data.cliente || {};
      const isAdmin = !!cliente.is_admin || (cliente.email && cliente.email.toLowerCase() === 'admin@loucasporbeleza.com.br');
      if (isAdmin) {
        navigate('/admin/dashboard', { replace: true });
      } else {
        navigate('/minha-conta', { replace: true });
      }
      window.location.reload();
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      setError(error.response?.data?.error || 'Erro ao fazer login. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="container">
        <div className="login-container">
          <h1 className="page-title">Login</h1>
          
          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="seu@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="senha">Senha</label>
              <input
                type="password"
                id="senha"
                name="senha"
                value={formData.senha}
                onChange={handleChange}
                required
                placeholder="Digite sua senha"
              />
            </div>

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Entrando...' : 'Entrar'}
            </button>

            <div className="form-footer">
              <p>Não tem uma conta? <Link to="/cadastro-cliente">Cadastre-se</Link></p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;

